import {
  STORE_SESSION_INFO,
  STORE_VISITOR_TOKEN,
  INIT_WEBSOCKET,
  INIT_WEBSOCKET_UNAUTHORIZED,
  REQUEST_LOGIN_PRESALE,
  TRYING_TO_ESTABLISH_WEBSOCKET_CONNECTION,
  WEBSOCKET_CONNECTION_ESTABLISHED,
  SET_AI_ASSISTANT_THREAD_ID
} from '../app-communication/actions/from-client-frontend';

import { CLIENT_TOKEN_UPDATED } from '../app-communication/actions/from-main-app';
import { VISITOR_AUTH_FAILED, VISITOR_AUTH_SUCCESS, CHAT_NOT_EXISTS } from '../app-communication/actions/from-cluster';
import { CLEAR_STORE } from '../constants';

export const initialState = {
  visitorToken: null,
  lastChatVisitorToken: null,
  unauthorized: false,
  IMPULSE_URLS: [],
  CHAT_API: null,
  clientToken: null,
  username: null,
  reconnectErrors: [],
  isWebsocketConnectivityActive: true,
  aiAssistantThreadId: null
};

export const chatSessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_WEBSOCKET_UNAUTHORIZED:
      return {
        ...state,
        unauthorized: true
      };
    case VISITOR_AUTH_SUCCESS:
      return {
        ...state,
        visitorToken: action.payload.visitorToken,
        lastChatVisitorToken: action.payload.visitorToken
      };
    case REQUEST_LOGIN_PRESALE:
      return {
        ...state,
        firstName: action.payload.name
      };
    case STORE_VISITOR_TOKEN:
      return {
        ...state,
        ...action.payload
      };
    case STORE_SESSION_INFO:
      return {
        ...state,
        ...action.payload
      };
    case CLIENT_TOKEN_UPDATED:
      return {
        ...state,
        clientToken: action.payload.clientToken
      };
    case CHAT_NOT_EXISTS:
      return {
        ...state,
        visitorToken: null,
        // used for submitting reviews/transcript after chat is closed
        // will not be used after page reload, clear on INIT_WEBSOCKET
        lastChatVisitorToken: state.visitorToken || state.lastChatVisitorToken
      };
    case VISITOR_AUTH_FAILED:
    case CLEAR_STORE:
      return {
        ...state,
        visitorToken: null,
        lastChatVisitorToken: null
      };
    case TRYING_TO_ESTABLISH_WEBSOCKET_CONNECTION:
      return {
        ...state,
        isWebsocketConnectivityActive: false
      };
    case WEBSOCKET_CONNECTION_ESTABLISHED:
      return {
        ...state,
        isWebsocketConnectivityActive: true
      };
    case SET_AI_ASSISTANT_THREAD_ID:
      return {
        ...state,
        aiAssistantThreadId: action.payload
      };
    default:
      return state;
  }
};
